/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from '../../constants/Colors';
import {FontWeight, Text} from '../Text';
import {Breakpoints} from "../../constants/Breakpoints";

const Container = styled.div`
  margin-top: 25px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  padding-bottom: 0px;
  padding: 0 0 1.5rem;
  flex-direction: column-reverse;

  @media screen and (min-width: ${Breakpoints.sm}) {
    padding: 2rem 0 0;
    flex-direction: unset;
  }

  .profile-open{
    right: 0px;
  }

`;

const Column = styled.div`
  margin-bottom: 30px;
  min-width: 93px;
  text-align: center;
  padding: 0 1.5rem;
  width: 100%;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    min-width: unset;
    text-align: unset;
    padding: unset;
    width: unset;
  }
`;

const Title = styled(Text)`
  line-height: 1;
  width: 100%;
  text-align: left;
  font-size: 22px;
  display: block;
  margin-bottom: .25rem;
  font-weight: ${FontWeight.Bold};
  color1: ${Colors.WHITE};
  color: ${Colors.GRAY[6]};

  @media screen and (min-width: ${Breakpoints.sm}) {
    text-align: unset;
    width: unset;
    line-height: 1.4;
    font-size: 32px;
  }
`;

const Subtitle = styled(Text)`
  display: block;
  font-size: 14px;
  width: 100%;
  text-align: left;
  font-weight: ${FontWeight.Medium};
  color1: ${Colors.WHITE};
  color: ${Colors.GRAY[6]};

  @media screen and (min-width: ${Breakpoints.sm}) {
    font-size: 16px;
    display: unset;
    width: unset;
    text-align: unset;
  }
`;

const Logo = styled.img`
  width: 65%;
  max-height: 120px;
  margin: 2rem 4px;
  max-inline-size: min-content;

  @media screen and (min-width: ${Breakpoints.sm}) {
    width: 100%;
  }
`;

const ContentProfile = styled.div`
  right: -340px;
  width: 340px;
  height: 100vh;
  position: fixed;
  background: ${Colors.WHITE};
  box-shadow: -5px 0px 6px 1px rgba(179,174,174,0.17);
  z-index: 10;
  top: 0px;
  transition: all 0.5s ease;
  overflow-y: auto;
  overflow-x: hidden;

  .icon-close{
    z-index: 100;
    position: relative;
    margin: 10px 15px;
    font-size: 30px;
    cursor: pointer;
    float: left;
  }
`;

const User = styled.div`
  width: 50px;
  float: right;

  @media (min-width: ${Breakpoints.lg}) {
    width: 250px;
  }

  @media (min-width: ${Breakpoints.sm}) {
    width: 70px;
  }
`;

const Photo = styled.div`
  width: 50px;
  height: 50px;
  background: #fff;
  box-shadow: 0px 8px 20px 3px rgba(171, 171, 171, 0.22);
  border-radius: 50px;
  margin-top: -10px;
  padding-top: 10px;
  margin-right: 20px;
  float: left;

  .icon-user:before{
    background-size: contain;
    width: 32px;
    height: 27px;
    border-radius: 8px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 2px;
  }

  .icon-check-ok{
    margin-left: 40px;
    margin-top: -5px;
    float: right;
  }

  .icon-check-ok:before {
    background-size: contain;
    display: inline-block;
    width: 20px;
    height: 20px;
    content: "";
    border-radius: 20px;
  }

  @media (min-width: ${Breakpoints.sm}) {
    width: 60px;
    height: 60px;

    .icon-user:before{
      width: 38px;
      height: 32px;
    }

    .icon-check-ok:before {
      width: 24px;
      height: 24px;
    }
  }
`;

const Name = styled(Text)`
  font-size: 16px;
  display: none;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};
  
  @media (min-width: ${Breakpoints.lg}) {
      display: block;
  }
`;

const Country = styled(Text)`
  font-size: 15px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};
  display: none;

  @media (min-width: ${Breakpoints.lg}) {
    display: unset;
  }
`;

export { Container, Column, Title, Subtitle, Logo, ContentProfile, Country,Name, Photo, User};
